import { render } from "./ChannelHome.vue?vue&type=template&id=1f2cab32&scoped=true"
import script from "./ChannelHome.vue?vue&type=script&lang=js"
export * from "./ChannelHome.vue?vue&type=script&lang=js"

import "./ChannelHome.vue?vue&type=style&index=0&id=1f2cab32&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2cab32"]])

export default __exports__